import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Contact } from '@/api/endpoints/contact/useGetCommunityContacts';
import { CreateContactDto } from '@/api/models/contact';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';

export const useCreateCommunityContact = () => {
  const { session } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ communityId, data }: { communityId: number; data: CreateContactDto }) =>
      handleApiCall<Contact, CreateContactDto>(
        session,
        'POST',
        `contacts/community?community_id=${communityId}`,
        data
      ),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['contacts', 'community', variables.communityId] });
    },
  });
};